import { Component, OnInit } from "@angular/core";
import { UserRepository } from "../../../domain/user-repository";
import { TenantRepository } from "../../../domain/tenant-repository";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { EditUserViewModel } from "../ViewModels/EditUserViewModel";
import { ChannelRepository } from "../../../domain/channel-repository";
import { RoleNames } from "../../../domain/user";

@Component({
  selector: "edit-user",
  templateUrl: "./edit-user.component.html",
  styleUrls: ["./edit-user.component.scss"],
})
export class EditUserComponent implements OnInit {
  userVM: EditUserViewModel;

  constructor(
    private usersRepository: UserRepository,
    private tenantRepository: TenantRepository,
    private route: ActivatedRoute,
    private channelsRepository: ChannelRepository,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      // tslint:disable-next-line:radix
      const userIdParam = parseInt(params["id"]);
      this.initForm(userIdParam);
    });
  }

  async initForm(userId: number) {
    const allTenants = await this.tenantRepository.getAll();
    const currentUser = this.usersRepository.getCurrentUser();
    const tenantIdFilter = null;
    const editableUser = (
      await this.usersRepository.getUsers(userId, tenantIdFilter)
    )[0].clone();

    const allActionPermissionVMs = this.initActionPermissionsVM();

    this.userVM = new EditUserViewModel(
      currentUser,
      editableUser,
      allTenants,
      allActionPermissionVMs,
      false,
      true,
      true,
      this.usersRepository.validateUsernameExists.bind(this.usersRepository),
      this.channelsRepository.getTenantChannels.bind(this.channelsRepository),
      this.tenantRepository.create.bind(this.tenantRepository),
    );
    this.userVM.applyClicked.subscribe(async () => {
      console.log("edit user: applyForm");
      await this.usersRepository.updateUser(this.userVM.editableUser);
      await this.router.navigateByUrl("/users/list");
    });

    this.userVM.twoFactowWasReset.subscribe(() => {
      this.userVM.editableUserBeforeChanges.hasTwoFactor = false;
      this.usersRepository.updateUser(this.userVM.editableUserBeforeChanges);
    });
    this.userVM.userPasswordChanged.subscribe(async (newPassword) => {
      await this.usersRepository.resetPassword(
        this.userVM.editableUserBeforeChanges.userId,
        newPassword,
      );
      console.log("userPasswordChanged->finished");
    });

    console.log("edit-user: vm ", this.userVM);
  }

  private initActionPermissionsVM() {
    let result = [
      {
        displayTitle: "Manage Users",
        value: RoleNames.UsersManager,
      },
      {
        displayTitle: "Manage MAM",
        value: RoleNames.MAM_Editor,
      },
      {
        displayTitle: "Manage External MAM",
        value: RoleNames.External_MAM_Editor,
      },
      {
        displayTitle: "Download Media",
        value: RoleNames.DownloadMedia,
      },
      {
        displayTitle: "Batch Upload",
        value: RoleNames.BatchUpload,
      },
      {
        displayTitle: "QC Approval",
        value: RoleNames.QCApproval,
      },
      {
        displayTitle: "Manage Recordings",
        value: RoleNames.RecordingManager,
      },
      {
        displayTitle: "Manage Media Transcoding Jobs",
        value: RoleNames.MediaTranscoderManager,
      },
      {
        displayTitle: "Manage Live Broadcasting",
        value: RoleNames.LiveManager,
      },
      {
        displayTitle: "Manage Smart Planner",
        value: RoleNames.SmartPlannerManager,
      },
      {
        displayTitle: "Content Control Planner",
        value: RoleNames.ContentControlManager,
      },
      {
        displayTitle: "Manage Broadcasts",
        value: RoleNames.BroadcastsManager,
      },
      {
        displayTitle: "Destinations Manager",
        value: RoleNames.DestinationsManager,
      },
      {
        displayTitle: "Destinations Editor",
        value: RoleNames.DestinationsEditor,
      },
      {
        displayTitle: "Destinations Viewer",
        value: RoleNames.DestinationsViewer,
      },
    ];

    if (this.usersRepository.getCurrentUser().isSuperUser) {
      result = [
        {
          displayTitle: "Super User",
          value: RoleNames.SuperUser,
        },
        {
          displayTitle: "API User",
          value: RoleNames.ApiUser,
        },
        {
          displayTitle: "Create Channels",
          value: RoleNames.ChannelCreator,
        },
        ...result,
      ];
    }

    return result;
  }
}
